import React from "react"
import PropTypes from 'prop-types';
import { Row,Col,Panel } from "react-bootstrap"
import  { warning } from '../../../utils/constants'

const box = { 
	textAlign: 'left',
	minWidth: '180px',
	maxHeight:'120px',
    padding: '0',
    margin:'0',
	fontSize:'13px',
    fontWeight:'bold',
    cornerRadius:0,
    backgroundColor:'lightyellow'
}

const Stats = (props) => {

const { 
    totalEvents,
    paymentDue ,
    balance,
    amountPaid,
    eventDirector
} = props

const balanceColor = balance >= 0 ? 'green':'red'

return (<Row>
<Col sm={2}  >
    <Panel  style={{ ...box }}>
        <p  style={{ color:warning, marginTop:'-10px' }}>{eventDirector}</p>
        <p  style={{  marginTop:'-8px' }}>Events: {totalEvents}</p>
        <p  style={{  marginTop:'-8px' }}>Amount Paid: ${amountPaid}</p>
        <p  style={{  marginTop:'-8px' }}>Payment Due:  ${paymentDue}</p>
        <p style={{  marginTop:'-8px', paddingBottom:'0' }}>Balance: <span style={{ color:balanceColor, fontWeight:'bold' }}> &nbsp;&nbsp;${balance}</span></p>
    </Panel>
</Col>

</Row>)
}
Stats.propTypes = {
    totalEvents: PropTypes.number,
    amountPaid: PropTypes.number,
    balance: PropTypes.number,
    paymentDue: PropTypes.number,
    eventDirector: PropTypes.string
}

export default Stats


// WEBPACK FOOTER //
// ./src/containers/deposit/components/stats.js